import { type SignupRequest } from '@/api/routes/public/auth.api';
import { type SignupFormData } from '@/domain/auth/types';

/**
 * Sign-up body sent by the portal. `source: 'partners_web'` makes the API point the activation
 * and password reset e-mails at the portal instead of the professional web app.
 */
export const toSignupRequest = ({
  email,
  firstName,
  lastName,
  password,
  receivePlatformUpdateEmails,
}: SignupFormData): SignupRequest => ({
  email: email.trim(),
  firstName: firstName.trim(),
  lastName: lastName?.trim() || undefined,
  password,
  receivePlatformUpdateEmails,
  acceptedTerms: true,
  source: 'partners_web',
});
